RivalIQ.module('utils', function (utils, App, Backbone, Marionette, $, _) {

    'use strict';

    utils.url = {};

    /**
     * Creates an override URL function with an optional time period type.
     * @param url
     * @param [timePeriodType]
     */
    utils.url.createOverrideUrl = function (url, timePeriodType) {

        const timePeriods = RivalIQ.state.timePeriods;

        timePeriodType = (timePeriodType || RivalIQ.enums.timePeriod.type.LAST_SEVEN_DAYS);

        return function () {

            const activeTimePeriod = RivalIQ.state.view.get('timePeriod');
            const timePeriod = timePeriods.getDefinitionByType(timePeriodType);

            if (activeTimePeriod.id === timePeriod.id) {

                return url;
            }

            return `/api/setViewState?${utils.url.param({
                url: url,
                timePeriod: JSON.stringify(timePeriod),
                landscapeId: RivalIQ.state.view.get('landscapeId')
            })}`;
        };
    };


    /**
     * This method removes the protocol from the URL string. "http://rivaliq.com" becomes "rivaliq.com".
     * @param {String} url - A URL that you want to strip the protocol off of
     * @returns {String} - A URL that no longer has the protocol on it
     */
    utils.url.stripHypertextProtocol = function (url) {

        let results;

        // a nice little trick using the smartness of the DOM
        // https://developer.mozilla.org/en-US/docs/Web/API/Location
        if (utils.url.isHypertextProtocolSpecified(url)) {

            const hasTrailingSlash = (/\/$/).test(url);
            const a = document.createElement('a');
            a.href = url;
            results = a.href.replace(`${a.protocol}//`, '');

            if (!hasTrailingSlash) {

                //the DOM will sometimes add a / (slash) to the end. Get rid of it if the url didn't originally have it
                results = results.replace(/\/+$/, '');
            }
        } else {

            results = url;
        }

        return results;
    };

    /**
     * Checks to see whether or not a the URL has a protocol specified (i.e. http or https)
     * @param url
     * @returns {boolean}
     */
    utils.url.isHypertextProtocolSpecified = function (url) {

        return (/^http(s)?\:\/\//i).test(url);
    };

    (function () {

        const space = encodeURIComponent(' ');

        /**
         * Turns things into parameters suitable for URLs.
         * @returns {string}
         */
        utils.url.param = function () {

            const params = $.param.apply($, arguments);
            const result = params.replace(/\+/ig, space);
            return result;
        };

    }());

});
